<!-- 
CustDataViewPermissionContent.vue
功能：客戶資料檢視權限_解除權限資訊
作者：i94005pi01 周厚鈞
完成：2022-11-03
-->
<template>
  <div class="container" v-show="isEdit">
    <div class="row">
      <div class="mt-4 pb-2 text-red text-bold">※解除完成後，需等隔日清晨批次更新後才會生效。</div>
      <table class="table table-basic mb-4">
        <thead>
          <tr>
            <th class="w-220">設定人員</th>
            <td>
              <Tooltip
                  position="bottom"
                  expand_col1="設定人員"
                  :expand_col1_value="permissionInfo.upd_name"
                  expand_col2="客戶ID"
                  :expand_col2_value="permissionInfo.id"
                  expand_col3="業務員ID"
                  :expand_col3_value="permissionInfo.agnt_id"
              >
                {{ permissionInfo.upd_name | getMaskName }}
              </Tooltip> 
            </td>
          </tr>
          <tr>
            <th class="w-220">簡覆表編號</th>
            <td>{{ permissionInfo.form_no }}</td>
          </tr>
          <tr>
            <th class="w-220">申請日期</th>
            <td>{{ permissionInfo.in_date | dateFormat }}</td>
          </tr>
          <tr>
            <th class="w-220">客戶ID</th>
            <td>{{ permissionInfo.id | getMaskID  }}</td>
          </tr>
          <tr>
            <th class="w-220">設定範圍</th>
            <td>{{ permissionInfo.in_type == '1' ? '特定業務員' : '全部業務員' }}</td>
          </tr>
          <tr>
            <th class="w-220">業務員ID</th>
            <td>{{ permissionInfo.agnt_id | emptyField | getMaskID   }}</td>
          </tr>
          <tr>
            <th class="w-220">原因</th>
            <td>{{ permissionInfo.memo }}</td>
          </tr>
        </thead>
      </table>
      <table class="table table-basic mt-4 mb-4">
        <thead>
          <tr>
            <th class="w-220">設定人員</th>
            <td>
              <Tooltip
                  :position="index < 3 ? 'bottom' : 'top'"
                  expand_col1="設定人員"
                  :expand_col1_value="UserInfo.name"
              >
                {{ UserInfo.name | getMaskName }}
              </Tooltip> 
            </td>
          </tr>
          <tr>
            <th class="w-220"><span style="color: red;">*</span>簡覆表編號</th>
            <td>
              <input
                type="text"
                maxlength="30"
                :id="`div-del_form_no`"
                :data-vv-name="`div-del_form_no`"
                placeholder="請輸入簡覆表編號"
                v-validate="'required|checkEngNum'"
                data-vv-as="簡覆表編號"
                class="form-control w-50"
                v-model="form.del_form_no"
                :class="{ 'is-invalid': errors.has(`div-del_form_no`) }"
              />
            </td>
          </tr>
          <tr>
            <th class="w-220">申請日期</th>
            <td>{{ moment().getROCDate('YYYY/MM/DD') }}</td>
          </tr>
          <tr>
            <th class="w-220">設定範圍</th>
            <td>取消權限設定</td>
          </tr>
          <tr>
            <th class="w-220"><span style="color: red;">*</span>異動原因</th>
            <td>
              <input
                type="text"
                maxlength="30"
                :id="`div-del_memo`"
                :data-vv-name="`div-del_memo`"
                placeholder="請輸入異動原因"
                v-validate="'required'"
                data-vv-as="異動原因"
                class="form-control w-50"
                v-model="form.del_memo"
                :class="{ 'is-invalid': errors.has(`div-del_memo`) }"
              />
            </td>
          </tr>
        </thead>
      </table>
      <div class="col-12">
        <div class="action text-right">
          <a class="btn btn-default" @click="doCancel">取消</a>
          <a class="btn btn-primary" @click="doSubmit">確定</a>
        </div>
      </div>
    </div>
    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" :content="mxMaskContent" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
import { Validator } from 'vee-validate';
//component
import mxMask from "@/desktop/components/mxMask";
import Tooltip from "@/desktop/components/ToolTip";
//service
import { delCustDataViewPermission } from "@/service";
export default {
  name: "CustDataViewPermissionContent",
  mixins: [commonMixin],
  components: { mxMask,
    Tooltip
   },
  props: {
    //客戶資料檢視權限資訊
    permissionInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    //查詢模式
    selectKey: {
      type: String,
      default: () => {
        return "";
      }
    },
    //編輯中
    isEdit: {
      type: Boolean,
      default: () => {
        return true;
      }
    }
  },
  computed: {
    ...mapGetters(["UserInfo"])
  },
  watch: {
    isEdit: function(val) {
      if (val) {
        this.setFormValue();
      }
    }
  },
  data() {
    return {
      mxMaskOpen: false,
      mxMaskContent: "資料儲存中，請稍候...",
      form: {
        agnt_id: "",
        id: "",
        in_type: "",
        form_no: "",
        memo: "",
        upd_id: "",
        in_date: "",
        in_time: "",
        upd_time: "",
        del_form_no: "", //刪除簡覆表編號
        del_memo: "", //刪除原因
      },
    };
  },
  methods: {
    ...mapActions(["setPageLock"]),
    // 初始自訂義檢核
    initValidator() {
      Validator.extend('checkEngNum', {
        getMessage: field => {
          return `${field}不可輸入英文、數字以外內容`;
        },
        validate: value => {
          let isNonEmpty = value.trim().length > 0;
          let isFormatCurrect = /^[a-zA-Z0-9\\]*$/.test(value);
          return isNonEmpty && isFormatCurrect;
        }
      });
    },
    //取消編輯
    doCancel() {
      this.setToastMsg("編輯取消");
      this.$emit("doCancelEdit");
    },
    //重設
    doReset(showMsg) {
      this.form = {
        agnt_id: "",
        id: "",
        in_type: "",
        form_no: "",
        memo: "",
        upd_id: "",
        in_date: "",
        in_time: "",
        upd_time: "",
        del_form_no: "", //刪除簡覆表編號
        del_memo: "", //刪除原因
      };
      if (showMsg) {
        this.$toast.info({ title: "畫面重設成功" });
      }
    },
    doSubmit() {
      //檢核
      this.$validator.validateAll().then(el => {
        if (!el) {
          let errMsg = [];
          for (let i = 0; i < this.errors.items.length; i++) {
            errMsg.push(this.errors.items[i].msg);
          }
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach(s => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
        } else {
          this.callApi();
        }
      });
    },
    callApi() {
      const reqData = {
        form_agnt_id: this.form.agnt_id.trim(), // 業務員ID
        id: this.form.id.trim(), // 客戶ID
        in_type: this.form.in_type, // 設定範圍
        form_no: this.form.form_no.trim(), // 簡覆表編號        
        upd_id: this.form.upd_id, // 編輯人員ID
        memo: this.form.memo, // 原因
        in_date: this.form.in_date, // 申請日期
        in_time: this.form.in_time, // 新增時間
        upd_time: this.form.upd_time, // 異動時間
        del_form_no: this.form.del_form_no, //刪除簡覆表編號
        del_memo: this.form.del_memo, //刪除原因
        del_id: this.UserInfo.id, //刪除編輯人員ID
      };
      this.mxMaskOpen = true;
      delCustDataViewPermission(this.UserInfo.id, reqData).then(result => {
        this.mxMaskOpen = false;
        if (result.header && result.header.status == '200') {
          //編輯成功, 關閉編輯區塊, 重新查詢
          this.$emit("doQuery", this.selectKey);
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });

      this.$validator.reset();
    },
    //編輯模式塞值
    setFormValue() {
      if (this.permissionInfo) {
        this.doReset(false); //清空畫面上原有的值
        setTimeout(()=>{
          this.form.agnt_id = this.ensureData(this.permissionInfo.agnt_id);
          this.form.id = this.ensureData(this.permissionInfo.id);
          this.form.in_type = this.ensureData(this.permissionInfo.in_type);
          this.form.form_no = this.ensureData(this.permissionInfo.form_no);
          this.form.memo = this.ensureData(this.permissionInfo.memo);
          this.form.upd_id = this.ensureData(this.permissionInfo.upd_id);
          this.form.in_date = this.ensureData(this.permissionInfo.in_date);
          this.form.in_time = this.ensureData(this.permissionInfo.in_time);
          this.form.upd_time = this.ensureData(this.permissionInfo.upd_time);
        },100)
      }
    },
    ensureData(value){
      return value !== undefined ? value : ''
    }
  },
  mounted() {
    this.initValidator();
  }
};
</script>